import { html, type TemplateResult } from 'lit-html'

import type { App } from '../app.ts'
import { defineScreen } from '../screen.ts'
import { paragraphs } from '../text.ts'

/**
 * The code of the Guild (#68, Q28.2): `codeOfConductHeading` over the three
 * paragraphs of `codeOfConduct`, on a screen of its own.
 *
 * Reached by a quiet link at the foot of the landing and from the desk, so
 * it is the one screen a visitor who is not signed in may read besides the
 * landing itself. It is also read once after the welcome, before the
 * practice offer, where the auth screen draws the same paragraphs with
 * `codeOfConductAgree` under them; that first read is the auth screen's
 * business, and this screen never asks whether it happened.
 *
 * Nothing to load and nothing to hold: the store is empty.
 */

type State = Record<never, never>

/** The three paragraphs, as the welcome's are drawn (#94). */
export const codeParagraphs = (app: App): TemplateResult[] =>
  paragraphs(app.content.guildVoice(app.locale).codeOfConduct).map(
    (paragraph) => html`<p>${paragraph}</p>`,
  )

export const codeScreen = defineScreen<State>({
  id: 'code',
  initial: {},

  enter() {
    // Nothing is fetched: the code is content, and content is already here.
  },

  render(_state, app) {
    return html`<section class="screen screen-narrow screen-code">
      <h1 class="title">${app.t('codeOfConductHeading')}</h1>
      <div class="code">${codeParagraphs(app)}</div>
      ${
        // A visitor who is not signed in has no navigation to leave by, so
        // the way back to the landing is drawn under the code. A signed-in
        // player has the five keys.
        app.user === null
          ? html`<p class="row">
              <button class="quiet code-back" @click=${() => app.go({ screen: 'auth' })}>
                ${app.t('stepBack')}
              </button>
            </p>`
          : null
      }
    </section>`
  },
})
